import { IMessageContainers } from "../../MessageComponents/Enums/MessageEnums";
import { IMessageHour, IMessageMinute, MessageType } from "../Typings/MessageText";

export const MessageTypes = {
  DirectEmailMessage: "DirectEmailMessage",
  DirectTextMessage: "DirectTextMessage",
  GroupEmailMessage: "GroupEmailMessage",
  GroupTextMessage: "GroupTextMessage",
  CampaignEmailMessage: "CampaignEmailMessage",
  CampaignTextMessage: "CampaignTextMessage",
  SystemEmailMessage: "SystemEmailMessage",
  SystemTextMessage: "SystemTextMessage",
  Stop: "Stop",
  ERROR: "ERROR",
  Read: "Read",
  ReplyText: "ReplyText",
  ReplyTextMessage: "ReplyTextMessage",
} as Record<string, MessageType>;

export const MessageContainersToTypes = {
  [IMessageContainers.CampaignWelcomeText]: MessageTypes.CampaignTextMessage,
  [IMessageContainers.CampaignWelcomeEmail]: MessageTypes.CampaignEmailMessage,
  [IMessageContainers.CandidateTextNow]: MessageTypes.DirectTextMessage,
  [IMessageContainers.CandidateEmailNow]: MessageTypes.DirectEmailMessage,
  [IMessageContainers.CandidateScheduledText]: MessageTypes.DirectTextMessage,
  [IMessageContainers.CandidateScheduledEmail]: MessageTypes.DirectEmailMessage,
  [IMessageContainers.GroupTextNow]: MessageTypes.GroupTextMessage,
  [IMessageContainers.GroupEmailNow]: MessageTypes.GroupEmailMessage,
  [IMessageContainers.GroupScheduledText]: MessageTypes.GroupTextMessage,
  [IMessageContainers.GroupScheduledEmail]: MessageTypes.GroupEmailMessage,
  [IMessageContainers.BulkTextNow]: MessageTypes.GroupTextMessage,
  [IMessageContainers.BulkEmailNow]: MessageTypes.GroupEmailMessage,
  [IMessageContainers.BulkScheduledText]: MessageTypes.GroupTextMessage,
  [IMessageContainers.BulkScheduledEmail]: MessageTypes.GroupEmailMessage,
  [IMessageContainers.None]: MessageTypes.Error,
};

export const timeBoundMessageTypes = [
  MessageTypes.DirectTextMessage,
  MessageTypes.GroupTextMessage,
  MessageTypes.CampaignTextMessage,
];

export const scheduleContainerTypes = [
  IMessageContainers.CandidateScheduledText,
  IMessageContainers.CandidateScheduledEmail,
  IMessageContainers.GroupScheduledText,
  IMessageContainers.GroupScheduledEmail,
  IMessageContainers.BulkScheduledText,
  IMessageContainers.BulkScheduledEmail,
];

export const defaultMessageHours: IMessageHour[] = [
  { messageHourId: 1, label: "12 pm", value: 12 },
  { messageHourId: 2, label: "1 pm", value: 13 },
  { messageHourId: 3, label: "2 pm", value: 14 },
  { messageHourId: 4, label: "3 pm", value: 15 },
  { messageHourId: 5, label: "4 pm", value: 16 },
  { messageHourId: 6, label: "5 pm", value: 17 },
];

export const defaultMessageMinutes: IMessageMinute[] = [
  { messageMinuteId: 1, label: "00", value: 0 },
  { messageMinuteId: 2, label: "05", value: 5 },
  { messageMinuteId: 3, label: "10", value: 10 },
  { messageMinuteId: 4, label: "15", value: 15 },
  { messageMinuteId: 5, label: "20", value: 20 },
  { messageMinuteId: 6, label: "25", value: 25 },
  { messageMinuteId: 7, label: "30", value: 30 },
  { messageMinuteId: 8, label: "35", value: 35 },
  { messageMinuteId: 9, label: "40", value: 40 },
  { messageMinuteId: 10, label: "45", value: 45 },
  { messageMinuteId: 11, label: "50", value: 50 },
  { messageMinuteId: 12, label: "55", value: 55 },
];
